import React, { useState, useEffect } from 'react';
import { useI18n } from '../context/I18nContext';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const { t } = useI18n();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Verificar se o usuário já aceitou os cookies
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Pequeno delay para não aparecer imediatamente
      setTimeout(() => setShowBanner(true), 1000);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', JSON.stringify({
      accepted: true,
      date: new Date().toISOString(),
      essential: true,
      analytics: true,
      marketing: true
    }));
    setShowBanner(false);
  };

  const acceptEssentialOnly = () => {
    localStorage.setItem('cookieConsent', JSON.stringify({
      accepted: true,
      date: new Date().toISOString(),
      essential: true,
      analytics: false,
      marketing: false
    }));
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 animate-slide-up">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden">
        <div className="p-6">
          <div className="flex items-start gap-4">
            {/* Cookie Icon */}
            <div className="hidden sm:flex w-12 h-12 bg-amber-100 rounded-xl items-center justify-center flex-shrink-0">
              <svg className="w-6 h-6 text-amber-600" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1-.96-.02-1.87-.53-2.37-1.37-.5-.85-.54-1.9-.09-2.77-.67-.11-1.3-.4-1.83-.83-.54-.43-.97-.99-1.24-1.63-.76.18-1.57.1-2.28-.22-.71-.32-1.28-.84-1.64-1.5C12.35 2.03 12.18 2 12 2zm-1 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-3 3c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-5 2c-.83 0-1.5-.67-1.5-1.5S9.17 11 10 11s1.5.67 1.5 1.5S10.83 14 10 14z"/>
              </svg>
            </div>

            {/* Content */}
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{t('cookie.title')}</h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">{t('cookie.body')}</p>

              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                <button
                  onClick={acceptCookies}
                  className="px-6 py-2.5 bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-semibold rounded-lg hover:opacity-90 transition-opacity text-sm"
                >{t('cookie.acceptAll')}</button>
                <button
                  onClick={acceptEssentialOnly}
                  className="px-6 py-2.5 bg-gray-100 text-gray-700 font-medium rounded-lg hover:bg-gray-200 transition-colors text-sm"
                >{t('cookie.essentialOnly')}</button>
                <Link
                  to="/privacidade"
                  className="text-sm text-gray-500 hover:text-gray-700 underline"
                >{t('cookie.privacyPolicy')}</Link>
              </div>
            </div>
          </div>
        </div>

        {/* Cookie Types Info */}
        <div className="bg-gray-50 px-6 py-4 border-t border-gray-100">
          <div className="flex flex-wrap gap-4 text-xs text-gray-500">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
              <span><strong>{t('cookie.essential')}</strong>{t('cookie.essentialDesc')}</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
              <span><strong>{t('cookie.analytics')}</strong>{t('cookie.analyticsDesc')}</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
              <span><strong>{t('cookie.marketing')}</strong>{t('cookie.marketingDesc')}</span>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slide-up {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-slide-up {
          animation: slide-up 0.4s ease-out;
        }
      `}</style>
    </div>
  );
};

export default CookieConsent;
